import { node, string, bool, oneOf, shape, elementType } from "prop-types";
import deprecated from "prop-types-extra/lib/deprecated";
import { BUTTON_STATUS, BUTTON_TYPES, BUTTON_VARIANT } from "./enums";
export var buttonTypes = {
  children: node,
  className: string,
  disabled: bool,
  icon: shape({
    id: string
  }),
  iconOnRight: bool,
  isFullWidth: bool,
  isLoading: bool,
  minor: bool,
  noCcTheme: bool,
  spinnerGradientStopClassName: string,
  status: oneOf(Object.values(BUTTON_STATUS)),
  component: elementType,
  type: oneOf(Object.values(BUTTON_TYPES)),
  variant: oneOf(Object.values(BUTTON_VARIANT)),
  /* TODO : Deprecated props, removed when migration done */
  dataSpacer: deprecated(string, "Use `data-spacer` instead")
};